module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-bottom": "0.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292749061_07_ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292749061_08_ch1"
    }
  }, [_vm._v("1. Texas, Our Texas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292749061_09_ch2"
    }
  }, [_vm._v("2. Coming of Age in Waco and Austin—1950s Style")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292749061_10_ch3"
    }
  }, [_vm._v("3. Off to Dallas to Practice Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292749061_11_ch4"
    }
  }, [_vm._v("4. The 1960 Election: The New Frontier Beckons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_12_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Returning to Dallas Hat in Hand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_13_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Representing Labor Unions in Dallas, Texas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_14_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Dallas, 1966: The Federal Courts and the Winds of Change")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_15_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Radical Left Shows Up in Texas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_16_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A Gleeful Return to Austin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_17_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Changing the Face of the Texas House of Representatives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_18_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Life and Times with U.S. District Judge Jack Roberts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_19_ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Texas Department of Public Safety Gets Caught Snooping on “Radicals” at the Unitarian Church of Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_20_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Frank Erwin and "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v(" Take On the "), _c('i', [_vm._v("Rag")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_21_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Law and the Counterculture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_22_ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Austin Politics—Come the Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_23_ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Student Voting Comes of Age")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_24_ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Redistricting East Texas in the 1970s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_25_ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Mad Dog Memories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_26_ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Of Time on the River")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_27_ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. A Decade or So of Voting Rights Wars in Texas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_28_ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. “The Times They Are A-Changin’"), _c('span', {
    staticClass: "pad"
  }), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_29_ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The 1982 Elections: Triumph of the Yarborough Democrats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_30_ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. The 1990s and the Last Guffaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_31_ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. The Trail Doubles Back")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292749061_32_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The Mullinax & Wells law firm several years before I joined it. From left to right: Ted Robertson, later of the Texas Supreme Court; Sam Houston Clinton Jr., later of the Texas Court of Criminal Appeals; Otto Mullinax; Oscar Mauzy, later of the Texas Supreme Court; Nat Wells; and Charlie Morris."), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ab30b08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292749061_06_toc.vue
// module id = 72
// module chunks = 0